var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTwitterSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.788a8.543 8.543 0 01-2.357.592c.852-.474 1.494-1.206 1.809-2.1a8.498 8.498 0 01-2.603.915C16.104.463 15.03 0 13.851 0c-2.264 0-4.108 1.701-4.108 3.79 0 .302.035.582.105.862-3.407-.162-6.44-1.67-8.46-3.963-.35.56-.56 1.206-.56 1.906 0 1.314.724 2.477 1.832 3.155a4.382 4.382 0 01-1.855-.474v.043c0 1.831 1.412 3.37 3.29 3.715-.35.087-.711.13-1.084.13-.269 0-.526-.022-.77-.065.524 1.508 2.041 2.606 3.838 2.627A8.7 8.7 0 01.98 13.352c-.327 0-.653-.021-.98-.053A12.334 12.334 0 006.29 15c7.549 0 11.68-5.772 11.68-10.779 0-.161 0-.323-.012-.495A7.485 7.485 0 0020 1.788z",
    fill: "#0A3F46"
  })));
}

export default SvgIconTwitterSimple;